/**
 * Shared helpers for the Lists module.
 *
 * Colour logic lives here rather than inline in JSX, per the design language's
 * status-pill rule.
 */

export function statusPillClass(isActive: boolean): string {
    return isActive
        ? 'text-emerald-600 border border-emerald-300 bg-emerald-50'
        : 'text-muted-foreground border border-border bg-muted/40';
}

export function statusLabel(isActive: boolean): string {
    return isActive ? 'Active' : 'Inactive';
}

/** Tag pill styling, fixed by the spec. */
export const TAG_PILL_CLASS =
    'text-xs font-medium text-primary bg-accent px-2 py-1 rounded-md';

/** Renders an empty field as an en dash rather than blank space. */
export function orDash(value: string | null | undefined): string {
    return value && value.trim() ? value : '–';
}

/** Prefixes a bare domain so href always resolves off-site. */
export function externalHref(url: string): string {
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}
